export default {"src":"/_next/static/media/Stroke.f9b6d56f.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};